export default __webpack_public_path__ + "static/logo-9764f1db2cf1202aeeaf8e3c4c6cb8f9.svg";